// Mock data for APEKAI Places Landing Page

export const features = [
  {
    id: 1,
    title: "Importa desde cualquier fuente",
    description: "Pega un enlace de TikTok, Instagram, o cualquier web y nuestra IA extraerá automáticamente todos los lugares mencionados.",
    icon: "Link"
  },
  {
    id: 2,
    title: "Mapa visual inteligente",
    description: "Todos tus lugares guardados aparecen como pines en un mapa interactivo, organizados por categorías y colecciones.",
    icon: "MapPin"
  },
  {
    id: 3,
    title: "Descripciones automáticas",
    description: "La IA genera descripciones detalladas de cada lugar basándose en el contenido original que compartiste.",
    icon: "Sparkles"
  },
  {
    id: 4,
    title: "Planifica viajes con IA",
    description: "Dinos a dónde quieres ir, cuántos días y tu estilo de viaje. Te creamos el itinerario perfecto día a día.",
    icon: "Plane"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Encuentra inspiración",
    description: "Descubre un lugar increíble en TikTok, Instagram o cualquier web"
  },
  {
    step: 2,
    title: "Comparte el enlace",
    description: "Copia y pega el enlace en APEKAI Places"
  },
  {
    step: 3,
    title: "La IA hace la magia",
    description: "Extraemos los lugares, creamos descripciones y los ubicamos en el mapa"
  },
  {
    step: 4,
    title: "Planifica tu aventura",
    description: "Usa el Trip Planner para organizar tu viaje perfecto"
  }
];

export const plans = [
  {
    id: "free",
    name: "Gratis",
    subtitle: "Perfecto para tus primeros destinos",
    description: "",
    bananaHighlight: "15 🍌",
    features: [
      "Con anuncios",
      "15 🍌 mensuales",
      "Analiza TikTok, Instagram, Webs y Documentos con limitaciones",
      "Acceso básico a funciones"
    ],
    cta: "Elegir Gratis",
    highlighted: false
  },
  {
    id: "backpacker",
    name: "Mochilero",
    subtitle: "La opción favorita de los viajeros",
    description: "Añade hasta 200 lugares nuevos",
    badge: "MÁS VENDIDO",
    bananaHighlight: "200 🍌",
    features: [
      "Sin anuncios",
      "200 🍌 mensuales",
      "Planifica tus viajes e itinerarios",
      "Analiza TikTok, Instagram, Webs y Documentos",
      "Colecciones compartidas",
      "Acceso avanzado a todas las funciones"
    ],
    cta: "Elegir Mochilero",
    highlighted: true
  },
  {
    id: "business",
    name: "Business",
    subtitle: "La experiencia ilimitada definitiva",
    description: "Añade hasta 450 lugares nuevos",
    badge: "¡El más rentable!",
    bananaHighlight: "450 🍌",
    features: [
      "Sin anuncios",
      "450 🍌 mensuales",
      "Planifica tus viajes e itinerarios",
      "Analiza TikTok, Instagram, Webs y Documentos",
      "Colecciones compartidas",
      "Acceso avanzado a todas las funciones"
    ],
    cta: "Elegir Business",
    highlighted: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María García",
    location: "Barcelona, España",
    avatar: "MG",
    rating: 5,
    text: "¡Por fin una app que entiende cómo guardo lugares! Antes tenía miles de posts guardados en Instagram sin saber dónde estaban. Ahora todo está en mi mapa.",
    highlight: "Perfecta para organizar mis viajes"
  },
  {
    id: 2,
    name: "Carlos Rodríguez",
    location: "Ciudad de México",
    avatar: "CR",
    rating: 5,
    text: "El Trip Planner con IA es una locura. Le dije que quería 5 días en Japón con estilo cultural y me armó un itinerario mejor que cualquier agencia.",
    highlight: "El Trip Planner es increíble"
  },
  {
    id: 3,
    name: "Laura Martínez",
    location: "Buenos Aires, Argentina",
    avatar: "LM",
    rating: 5,
    text: "Uso TikTok constantemente para descubrir lugares. Esta app me cambió la vida: pego el link y automáticamente tengo el lugar guardado con toda la info.",
    highlight: "Integración perfecta con TikTok"
  }
];

export const stats = [
  { value: "100K+", label: "Lugares guardados" },
  { value: "25K+", label: "Viajeros activos" },
  { value: "150+", label: "Países cubiertos" },
  { value: "4.9", label: "Rating en stores" }
];

// Mascot images
export const mascot = {
  main: process.env.PUBLIC_URL + "/assets/monito_mochilero.png",
  basic: process.env.PUBLIC_URL + "/assets/monito_free.png",
  traveler: process.env.PUBLIC_URL + "/assets/monito_mochilero.png",
  pro: process.env.PUBLIC_URL + "/assets/monito_pro.png",
  walking: process.env.PUBLIC_URL + "/assets/monitos/mochilero/monito_caminando.gif",
  talking: process.env.PUBLIC_URL + "/assets/monitos/monito_mochilero_hablando_blanco.gif"
};

// Place category icons
export const categories = [
  {
    id: "city",
    name: "Ciudades",
    icon: process.env.PUBLIC_URL + "/assets/city.png",
    description: "Metrópolis y ciudades vibrantes"
  },
  {
    id: "landmark",
    name: "Monumentos",
    icon: process.env.PUBLIC_URL + "/assets/landmark.png",
    description: "Lugares históricos y emblemáticos"
  },
  {
    id: "nature",
    name: "Naturaleza",
    icon: process.env.PUBLIC_URL + "/assets/nature.png",
    description: "Parques, bosques y paisajes"
  },
  {
    id: "activity",
    name: "Activity",
    icon: process.env.PUBLIC_URL + "/assets/activity.png",
    description: "Tiendas y centros comerciales"
  },
  {
    id: "transport",
    name: "Transporte",
    icon: process.env.PUBLIC_URL + "/assets/transport.png",
    description: "Estaciones y conexiones"
  }
];

export const appScreenshots = {
  map: process.env.PUBLIC_URL + "/assets/map_paris.jpg",
  mapCTA: process.env.PUBLIC_URL + "/assets/flutter_16.jpg",
  placeDetail: process.env.PUBLIC_URL + "/assets/flutter_20.jpg",
  placeDetailFull: process.env.PUBLIC_URL + "/assets/flutter_18.png",
  tripPlanner: process.env.PUBLIC_URL + "/assets/flutter_13.jpg",
  placesList: process.env.PUBLIC_URL + "/assets/flutter_17.jpg",
  importContent: process.env.PUBLIC_URL + "/assets/flutter_19.jpg",
  myTrips: process.env.PUBLIC_URL + "/assets/flutter_21.jpg",
  share: process.env.PUBLIC_URL + "/assets/flutter_26.jpg",
  howItWorksExtra: process.env.PUBLIC_URL + "/assets/flutter_31.jpg"
};

// Trip Planner carousel images
export const tripPlannerScreenshots = [
  {
    id: 1,
    url: process.env.PUBLIC_URL + "/assets/flutter_13.jpg",
    title: "Destinos y duración",
    description: "Elige a dónde quieres ir y cuántos días"
  },
  {
    id: 2,
    url: process.env.PUBLIC_URL + "/assets/flutter_14.jpg",
    title: "Presupuesto y lugares",
    description: "Configura tu presupuesto y añade lugares de tu lista"
  },
  {
    id: 3,
    url: process.env.PUBLIC_URL + "/assets/flutter_15.jpg",
    title: "Tipo de viaje",
    description: "Personaliza el estilo: aventura, romántico, familiar..."
  }
];